import { Operation } from "@/Core/Client";
import { DatePickerProps } from "@/ui/datepicker";
import {
    getDateRangeStateValues,
    getFormattedDateString,
} from "@/utils/get-formatted-date";
import DateFiled from "../controlled-table/date-field";
import StatusField from "../controlled-table/status-field";

import FileUploadField from "@/app/shared/file-upload-field";
import { PhoneNumber, PhoneNumberProps } from "@/ui/phone-input";
import cn from "@/utils/class-names";
import { Control, Controller } from "react-hook-form";
import {
    FileInputProps,
    Input,
    InputProps,
    MultiSelect,
    MultiSelectOption,
    MultiSelectProps,
    NumberInput,
    NumberInputProps,
    Password,
    Radio,
    RadioProps,
    Select,
    SelectOption,
    SelectProps,
    Switch,
    SwitchProps,
    Textarea,
    TextareaProps,
} from "rizzui";
import { FelidType, Field } from "./crud-config";

export const operatorOptions: SelectOption[] = [
    {
        label: "Equal",
        value: Operation.eq,
    },
    {
        label: "Like",
        value: Operation.like,
    },
    {
        label: "greater than",
        value: Operation.gt,
    },
    {
        label: "greater than or equal",
        value: Operation.gte,
    },
    {
        label: "less than",
        value: Operation.lt,
    },
    {
        label: "less than or equal",
        value: Operation.lte,
    },
    {
        label: "Between",
        value: Operation.btn,
    },
];

export type FieldElementsType =
    | TextareaProps
    | InputProps
    | SwitchProps
    | RadioProps
    | FileInputProps
    | SelectProps<SelectOption>
    | NumberInputProps
    | PhoneNumberProps
    | (DatePickerProps & { onClear?: () => void });

export type FieldElementsProps = {
    fieldType: FelidType;
    minWidth?: string | undefined;
    field?: Field<any>;
    rerender?: JSX.Element;
    fieldValue?: any;
    register?: any;
    control?: Control<any, any>;
    ignoreOperators?: Operation[];
} & FieldElementsType;

export default function FieldElements({
    fieldType,
    rerender,
    field,
    minWidth,
    fieldValue,
    control,
    register,
    ignoreOperators,
    ...props
}: FieldElementsProps) {
    switch (fieldType) {
        case "operators":
            // props.options = operatorOptions.filterIf(
            //     ignoreOperators !== undefined && ignoreOperators.isNotEmpty(),
            //     (o) =>
            //         !ignoreOperators!.includes(o.value as unknown as Operation),
            // );

            (props as SelectProps<SelectOption>).options = [];

            console.log("value", props.value);

            return (
                <Select
                    size="md"
                    label="Operation"
                    className={cn(
                        "w-full",
                        minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        field?.className,
                    )}
                    placeholder="Select operation"
                    // options={operatorOptions.filterIf(
                    //     ignoreOperators !== undefined &&
                    //         ignoreOperators.isNotEmpty(),
                    //     (o) => !ignoreOperators.includes(o.value),
                    // )}
                    //getOptionDisplayValue={(option) => option.label}
                    //getOptionValue={(option) => option.value}
                    // value={operation}
                    // onChange={setOperation}
                    {...(props as SelectProps<SelectOption>)}
                />
            );

        case "select":
            (props as SelectProps<SelectOption>).size = "md";
            if (control && register)
                return (
                    <Controller
                        {...register}
                        control={control}
                        render={({ field: { value, onChange, onBlur } }) => (
                            <Select
                                className={cn(
                                    "w-full capitalize",
                                    `[@media(min-width:${minWidth})]:w-40`,
                                    props.className,
                                    field?.className,
                                )}
                                getOptionValue={(option) => option.label}
                                value={value}
                                onChange={onChange}
                                onBlur={onBlur}
                                dropdownClassName="!z-10 h-auto capitalize"
                                labelClassName="capitalize"
                                optionClassName="capitalize"
                                // getOptionDisplayValue={(option) => option.value}
                                // getOptionValue={(option) => option.value}
                                {...(props as SelectProps<SelectOption>)}
                                {...field?.props}
                            />
                        )}
                    />
                );
            else if (register)
                return (
                    <Select
                        className={cn(
                            "w-full capitalize",
                            `[@media(min-width:${minWidth})]:w-40`,
                            props.className,
                            field?.className,
                        )}
                        getOptionValue={(option) => option.label}
                        dropdownClassName="!z-10 h-auto capitalize"
                        labelClassName="capitalize"
                        optionClassName="capitalize"
                        // getOptionDisplayValue={(option) => option.value}
                        // getOptionValue={(option) => option.value}
                        {...(props as SelectProps<SelectOption>)}
                        {...field?.props}
                        {...register}
                    />
                );
            else
                return (
                    <Select
                        className={cn(
                            "w-full capitalize",
                            `[@media(min-width:${minWidth})]:w-40`,
                            props.className,
                            field?.className,
                        )}
                        getOptionValue={(option) => option.label}
                        dropdownClassName="!z-10 h-auto capitalize"
                        labelClassName="capitalize"
                        optionClassName="capitalize"
                        // getOptionDisplayValue={(option) => option.value}
                        // getOptionValue={(option) => option.value}
                        {...(props as SelectProps<SelectOption>)}
                        {...field?.props}
                    />
                );

        case "radio":
            if (register)
                return (
                    <Radio
                        size="md"
                        className={cn(
                            "w-full",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        {...(props as RadioProps)}
                        {...register}
                        {...field?.props}
                    />
                );
            else
                return (
                    <Radio
                        size="md"
                        className={cn(
                            "w-full",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        {...(props as RadioProps)}
                        {...field?.props}
                    />
                );

        case "password":
            if (register)
                return (
                    <Password
                        size="lg"
                        inputClassName="text-sm"
                        className={cn(
                            "w-full [&>label>span]:font-medium",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        {...(props as RadioProps)}
                        {...register}
                        {...field?.props}
                    />
                );
            else
                return (
                    <Password
                        size="lg"
                        inputClassName="text-sm"
                        className={cn(
                            "w-full [&>label>span]:font-medium",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        {...(props as RadioProps)}
                        {...field?.props}
                    />
                );

        case "phone":
            if (register && control)
                return (
                    <Controller
                        {...register}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <PhoneNumber
                                country="so"
                                value={value}
                                onChange={onChange}
                                inputClassName="rtl:pr-12"
                                buttonClassName="rtl:[&>.selected-flag]:right-2 rtl:[&>.selected-flag_.arrow]:-left-6"
                                className={cn(
                                    "w-full",
                                    "rtl:[&>.selected-flag]:right-0",
                                    minWidth &&
                                    `[@media(min-width:${minWidth})]:w-40`,
                                )}
                                {...(props as PhoneNumberProps)}
                                {...field?.props}
                            />
                        )}
                    />
                );
            else
                return (
                    <PhoneNumber
                        country="so"
                        inputClassName="rtl:pr-12"
                        buttonClassName="rtl:[&>.selected-flag]:right-2 rtl:[&>.selected-flag_.arrow]:-left-6"
                        className={cn(
                            "w-full",
                            "rtl:[&>.selected-flag]:right-0",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        {...(props as PhoneNumberProps)}
                        {...field?.props}
                    />
                );

        case "multiSelect":
            // const [multiSelect, setMultiSelect] = useState([]);
            if (register && control)
                return (
                    <Controller
                        {...register}
                        control={control}
                        render={({
                            field: { value, onChange, onBlur },
                            fieldState: { error },
                        }) => (
                            <MultiSelect
                                placeholder="Select Platform.."
                                // displayValue={renderDisplayValue}
                                selectClassName="ring-0 min-h-[35px] h-[35px]"
                                dropdownClassName="min-w-40"
                                placement="bottom-end"
                                selectedItemClassName="hidden first:block border-0"
                                // options={
                                //     (props as MultiSelectProps<MultiSelectOption>)
                                //         ?.options ?? []
                                // }
                                value={value}
                                onChange={onChange}
                                onBlur={onBlur}
                                error={error?.message}
                                // getOptionDisplayValue={renderCustomSocialMultiOption}
                                {...(props as MultiSelectProps<MultiSelectOption>)}
                                {...(field?.props as MultiSelectProps<MultiSelectOption>)}
                            />
                        )}
                    />
                );
            else
                return (
                    <MultiSelect
                        placeholder="Select Platform.."
                        // displayValue={renderDisplayValue}
                        selectClassName="ring-0 min-h-[35px] h-[35px]"
                        dropdownClassName="min-w-40"
                        placement="bottom-end"
                        selectedItemClassName="hidden first:block border-0"
                        // getOptionDisplayValue={renderCustomSocialMultiOption}
                        {...(props as MultiSelectProps<MultiSelectOption>)}
                        {...(field?.props as MultiSelectProps<MultiSelectOption>)}
                    />
                );

        case "textarea":
            if (register)
                return (
                    <Textarea
                        textareaClassName="h-20"
                        className="col-span-full"
                        {...(props as TextareaProps)}
                        {...register}
                        {...field?.props}
                    />
                );
            else
                return (
                    <Textarea
                        textareaClassName="h-20"
                        className="col-span-full"
                        {...(props as TextareaProps)}
                        {...field?.props}
                    />
                );

        case "file":
            if (register && control)
                return (
                    <Controller
                        {...register}
                        control={control}
                        render={({
                            field: { value, onChange, onBlur },
                            fieldState: { error },
                        }) => (
                            <FileUploadField
                                multiple={false}
                                accept="img"
                                className="col-span-full"
                                value={value}
                                onChange={(e) => onChange(e.target.files?.[0])}
                                onBlur={onBlur}
                                error={error?.message}
                                {...(props as FileInputProps)}
                                {...field?.props}
                            />
                        )}
                    />
                );
            else
                return (
                    <FileUploadField
                        multiple={false}
                        accept="img"
                        className="col-span-full"
                        {...(props as FileInputProps)}
                        {...field?.props}
                    />
                );

        case "multipleFiles":
            if (register && control)
                return (
                    <Controller
                        {...register}
                        control={control}
                        render={({
                            field: { onChange, onBlur },
                            fieldState: { error },
                        }) => (
                            <FileUploadField
                                accept="img"
                                className="col-span-full"
                                // value={(value as [])?.map(
                                //     (file: File) => file?.name ?? "",
                                // )}
                                onChange={(e) => onChange([...e.target.files])}
                                // onMultiple={(files) => onChange(files)}
                                onBlur={onBlur}
                                error={error?.message}
                                {...(props as FileInputProps)}
                                {...field?.props}
                            />
                        )}
                    />
                );
            else
                return (
                    <FileUploadField
                        accept="img"
                        className="col-span-full"
                        {...(props as FileInputProps)}
                        {...field?.props}
                    />
                );

        case "number":
            (props as NumberInputProps).formatType = "numeric";

            if (register)
                return (
                    <Controller
                        {...register}
                        control={control}
                        rules={{ valueAsNumber: true }}
                        render={({
                            field: { value, onChange, onBlur },
                            fieldState: { error },
                        }) => (
                            <NumberInput
                                className={cn(
                                    "w-full",
                                    minWidth && `[@media(min-width:${minWidth})]:w-40`,
                                )}
                                //thousandSeparator=","
                                value={value}
                                onChange={onChange}
                                onBlur={onBlur}
                                error={error?.message}
                                customInput={Input as React.ComponentType<unknown>}
                                {...(props as NumberInputProps)}
                                {...field?.props}
                            />
                        )}
                    />
                );
            else
                return (
                    <NumberInput
                        className={cn(
                            "w-full",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        defaultValue={fieldValue}
                        thousandSeparator=","
                        {...(props as NumberInputProps)}
                        {...field?.props}
                    />
                );

        case "switch":
            if (register)
                return (
                    <Switch
                        size="md"
                        defaultChecked={fieldValue}
                        {...(props as SwitchProps)}
                        {...register}
                        {...field?.props}
                    />
                );
            else
                return (
                    <Switch
                        size="md"
                        defaultChecked={fieldValue}
                        {...(props as SwitchProps)}
                        {...field?.props}
                    />
                );

        case "date":
            // const [date, setDate] = useState<string>();
            if (register)
                return (
                    <DateFiled
                        size="md"
                        // monthsShown={1}
                        // startDate={getFormattedDateString(fieldValue)}
                        selected={getFormattedDateString(fieldValue)!}
                        // value={getFormattedDateString(fieldValue)!}
                        dateFormat={"dd-MMM-yyyy"}
                        className={cn(
                            "w-full",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                            field?.className,
                        )}
                        placeholderText="Select created date"
                        // onChange={(date) => setDate(getFormattedDateString(date))}
                        inputProps={{
                            label: (props as DatePickerProps).label,
                            inputClassName: "h-9 [&_input]:text-ellipsis",
                        }}
                        maxDate={new Date()}
                        {...(props as DatePickerProps)}
                        {...register}
                        {...field?.props}
                    />
                );
            else
                return (
                    <DateFiled
                        size="md"
                        // monthsShown={1}
                        // startDate={getFormattedDateString(fieldValue)}
                        selected={getFormattedDateString(fieldValue)!}
                        // value={getFormattedDateString(fieldValue)!}
                        dateFormat={"dd-MMM-yyyy"}
                        className={cn(
                            "w-full",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                            field?.className,
                        )}
                        placeholderText="Select created date"
                        // onChange={(date) => setDate(getFormattedDateString(date))}
                        inputProps={{
                            label: (props as DatePickerProps).label,
                            inputClassName: "h-9 [&_input]:text-ellipsis",
                        }}
                        maxDate={new Date()}
                        {...(props as DatePickerProps)}
                        {...field?.props}
                    />
                );

        case "dateRange":
            (props as DatePickerProps).selectsRange = true;
            (props as DatePickerProps).dateFormat = "dd-MMM-yyyy";

            if (register)
                return (
                    <DateFiled
                        size="md"
                        className={cn(
                            "w-full",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        placeholderText="Select created date"
                        endDate={
                            getDateRangeStateValues(
                                (props as DatePickerProps)?.endDate?.toString(),
                            )!
                        }
                        selected={
                            getDateRangeStateValues(
                                fieldValue ??
                                (
                                    props as DatePickerProps
                                )?.selected?.toString(),
                            )!
                        }
                        startDate={
                            getDateRangeStateValues(
                                (
                                    props as DatePickerProps
                                )?.startDate?.toString(),
                            )!
                        }
                        inputProps={{
                            label: "Created Date",
                            labelClassName: `[@media(min-width:${minWidth})]:w-40 capitalize`,
                        }}
                        {...(props as DatePickerProps)}
                        {...register}
                        {...field?.props}
                    />
                );
            else
                return (
                    <DateFiled
                        size="md"
                        className={cn(
                            "w-full",
                            minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        )}
                        placeholderText="Select created date"
                        endDate={
                            getDateRangeStateValues(
                                (props as DatePickerProps)?.endDate?.toString(),
                            )!
                        }
                        selected={
                            getDateRangeStateValues(
                                fieldValue ??
                                (
                                    props as DatePickerProps
                                )?.selected?.toString(),
                            )!
                        }
                        startDate={
                            getDateRangeStateValues(
                                (
                                    props as DatePickerProps
                                )?.startDate?.toString(),
                            )!
                        }
                        inputProps={{
                            label: "Created Date",
                            labelClassName: `[@media(min-width:${minWidth})]:w-40 capitalize`,
                        }}
                        {...(props as DatePickerProps)}
                        {...field?.props}
                    />
                );

        case "status":
            if (register && control)
                return (
                    <Controller
                        {...register}
                        control={control}
                        render={({ field: { value, onChange, onBlur } }) => (
                            <StatusField
                                size="md"
                                placeholder="Select status"
                                getOptionValue={(option) => option.label}
                                dropdownClassName="!z-10 h-auto"
                                className={cn(
                                    "w-full",
                                    minWidth &&
                                    `[@media(min-width:${minWidth})]:w-40`,
                                    field?.className ?? "",
                                )}
                                value={value}
                                onChange={onChange}
                                onBlur={onBlur}
                                labelClassName={`[@media(min-width:${minWidth})]:w-40 capitalize`}
                                {...(props as SelectProps<SelectOption>)}
                                {...(field?.props as SelectProps<SelectOption>)}
                            />
                        )}
                    />
                );

            return (
                <StatusField
                    size="md"
                    placeholder="Select status"
                    getOptionValue={(option) => option.label}
                    dropdownClassName="!z-10 h-auto"
                    className={cn(
                        "w-full",
                        minWidth && `[@media(min-width:${minWidth})]:w-40`,
                        field?.className ?? "",
                    )}
                    labelClassName={`[@media(min-width:${minWidth})]:w-40 capitalize`}
                    {...(props as SelectProps<SelectOption>)}
                    {...(field?.props as SelectProps<SelectOption>)}
                />
            );

        case "jsxElement":
            return rerender;

        case "element":
            return rerender;

        default:
            if (register)
                return (
                    <Input
                        type={"text"}
                        size="md"
                        placeholder={`Search for ${(props as InputProps)?.label && (props as InputProps).label}...`}
                        inputClassName="ps-3 pe-9"
                        className={cn(
                            "w-full",
                            `[@media(min-width:${minWidth})]:w-40`,
                            field?.className,
                        )}
                        defaultValue={fieldValue} // using in a filter side
                        // {...field?.props}
                        {...props}
                        {...register}
                    />
                );
            else
                return (
                    <Input
                        type={field?.type ?? "text"}
                        size="md"
                        placeholder={`Search for ${(props as InputProps)?.label && (props as InputProps).label}...`}
                        inputClassName="ps-3 pe-9"
                        className={cn(
                            "w-full",
                            `[@media(min-width:${minWidth})]:w-40`,
                            field?.className,
                        )}
                        defaultValue={fieldValue} // using in a filter side
                        {...field?.props}
                        {...props}
                    />
                );
    }
}